import React from "react";
import PeopleBackground from "./images/new-peopeBackGround.png";
import TitleShape from "./images/title_shape.png";
import Star from "./images/stars.png";
import Vector from "./images/Vector.png";
import Person from "./images/person.png";
import Linestar from "./images/linestar.png";
const KeyBenefits = () => {
  return (
    <div className=" w-full max-w-screen-xl mx-auto px-4 md:px-8 flex flex-col md:flex-row md:gap-8 lg:gap-16 py-10">
      {/* Image Section */}

      <div className=" relative flex flex-col items-center md:flex-row md:gap-4 w-full md:w-1/2">
        <img
          src={PeopleBackground}
          alt="People Background"
          className="rounded-xl object-cover w-[400px] sm:w-full "
        />
        <div className="absolute w-full max-w-md bottom-[1px] bg-custom-pink text-white px-3 sm:px-6 py-6 md:py-2 lg:py-6  rounded-br-2xl rounded-tr-2xl inline-flex items-center shadow-lg">
          <span className="text-[40px] sm:text-5xl font-bold mr-2">25K</span>
          <div className="text-[10px] md:text-base font-medium">
            AI Career Assessments
            <br />
            Completed
          </div>
        </div>
      </div>

      {/* Text Content Section */}

      <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4 md:space-y-6 lg:space-y-8 w-full md:w-1/2">
        {/* Heading */}
        <h1
          className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight text-custom-blue"
          // style={{ fontFamily: "Barlow" }}
        >
          Take Control Of Your Future in the Age of AI
        </h1>

        {/* Paragraph */}
        <p
          className="text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed"
          style={{ fontFamily: "Roboto" }}
        >
          Welcome to our AI Job Assessment Tool. As AI and automation reshape
          industries, it's crucial to understand how these changes might affect
          your career. Our assessment provides a personalized analysis of the
          potential impact on your job role, helping you make informed decisions
          about your professional future.
        </p>

        {/* {Grey div with 4 headings } */}

        <div className="w-full bg-gray-200 rounded-3xl p-4 md:p-8 flex justify-between">
          {/* {left col div } */}
          <div className="flex flex-col justify-between gap-8">
            <div className="flex items-center space-x-2">
              <img
                src={Star}
                alt="AI Exposure"
                className="w-5 h-5 md:w-8 md:h-8"
              />
              <span className="text-sm lg:text-2xl leading-[26px] font-medium">
                AI Exposure
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <img
                src={Vector}
                alt="Detailed Reports"
                className="w-5 h-5 md:w-8 md:h-8"
              />
              <span className="text-sm lg:text-2xl leading-[26px] font-medium">
                Upskilling Tips
              </span>
            </div>
          </div>
          <div className="border-l border-gray-300" />
          {/* {right col div } */}
          <div className="flex flex-col justify-between gap-8">
            <div className="flex items-center space-x-2">
              <img
                src={Person}
                alt="Icon 3"
                className="w-5 h-5 md:w-8 md:h-8"
              />
              <span className="text-sm lg:text-2xl leading-[26px] font-medium whitespace-nowrap">
                Tailored Advice
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <img
                src={Linestar}
                alt="Icon 4"
                className="w-5 h-5 md:w-8 md:h-8"
              />
              <span className="text-sm lg:text-2xl leading-[26px] font-medium whitespace-nowrap">
                Stay Competitive
              </span>
            </div>
          </div>
        </div>
        {/* {make new dive here} */}
      </div>
    </div>
  );
};

export default KeyBenefits;
